import { z } from 'zod'

export const ADMINANALYTICSOVERVIEWGET_CONTRACT_VERSION = '1.0.0' as const
export const adminAnalyticsOverviewGetResponseSchema = z.unknown()
export type AdminAnalyticsOverviewGetResponse = z.infer<typeof adminAnalyticsOverviewGetResponseSchema>
